import PropTypes from 'prop-types';
import { useEffect, createContext, useState } from "react";
import { toast } from "../../../core/helpers/message-helper";
import { obtenerConvenciones } from '../../NominaTurnos/services/nomina-turnos-service';

const TurnosConvencionesContext = createContext({});

export function TurnosConvencionesProvider({ children }) {
    const [convenciones, setConvenciones] = useState([]);

    useEffect(() => {
        refrescarConvenciones();
    }, []);

    const refrescarConvenciones = async () => {
        const resp = await obtenerConvenciones();
        if (!resp.status) return toast.error(resp.message);
        setConvenciones(resp.data);
    };

    return (
        <TurnosConvencionesContext.Provider
            value={{
                convenciones,
                setConvenciones,
                refrescarConvenciones,
            }}
        >
            {children}
        </TurnosConvencionesContext.Provider>
    );
}

TurnosConvencionesProvider.propTypes = {
    children: PropTypes.element
}

export default TurnosConvencionesContext;
